<!-- 富文本 -->
<template>
  <rich-text v-if="isEditor" v-model="value" :placeholder="`请输入${item?.fieldName}`"  />
  <div v-else v-html="value"></div>
</template>
<script>
import RichText from '@/components/RichText/index.vue'
import { baseProps, controlItemManage } from '../control-web/index'
import { defineComponent } from 'vue'
export default defineComponent({
  name: 't-richtext',
  inheritAttrs: false,
  props: { ...baseProps, modelValue: { type: String } },
  emits: ['update:modelValue', 'my-change'],
  components: { RichText },
  setup(props, context) {
    return {
      ...controlItemManage(props, context)
    }
  }
})
</script>
